module.exports = __webpack_public_path__ + "img/mgh-kyoto-kawaramachi-jokyoji.723e59b3.jpg";